import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ConfigInstanceToken, ConfigInterface } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { faCheck, faCloudUploadAlt, faSave } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { downloadDocuments, selectDocument } from '../../../store/actions/docBox.action';
import { DocumentState } from '../../../store/state/document.state';
import { FormsState } from '../../../store/state/pace-forms.state';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'tr[pace-forms-document-list-entry]',
    templateUrl: './document-list-entry.component.html',
    styleUrls: ['./document-list-entry.component.scss'],
    standalone: false,
})
export class DocumentListEntryComponent {
    @Input()
    public document: DocumentState;

    @Output() public uploadDocForEntry = new EventEmitter<DocumentState>();

    public checkboxControl: FormControl;
    public formGroup: FormGroup;

    public faCheck = faCheck;
    public faSave = faSave;
    public faCloudUploadAlt = faCloudUploadAlt;
    public enableIndividualDownload: boolean;
    public constructor(
        private readonly formBuilder: FormBuilder,
        private readonly store: Store<FormsState>,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
    ) {
        this.checkboxControl = formBuilder.control({ value: false, disabled: false });
        this.formGroup = formBuilder.group({
            checkbox: this.checkboxControl,
        });
        this.enableIndividualDownload = this.configService.getEnableIndividualDocBoxDownload();
    }

    public downloadDocument(): void {
        this.store.dispatch(downloadDocuments({ docBoxIds: [this.document.docBoxId] }));
    }

    public selectDocument(): void {
        this.store.dispatch(selectDocument({ docBoxId: this.document.docBoxId }));
    }

    public uploadForEntry(): void {
        this.uploadDocForEntry.next(this.document);
    }
}
